export default {
  SINGLE: "single",
  MULTIPLE: "multiple",
}
